import React, { useRef, useEffect } from 'react';
import {useLongPress} from "components/elements/main/UnifiedLongPress";


export function UnifiedLongPressableObject({ item, index, onLongPress, children }) {
    const events = useLongPress(() => onLongPress(item, index), 500);
    return <div {...events}>{children}</div>;
}
